// extracted by mini-css-extract-plugin
export var videoContainer = "index-module--videoContainer--KB8Zq";
export var videoIframe = "index-module--videoIframe--IgvRJ";